import * as React from 'react';
import {styled, mq} from '../../../utils';
import {FormikProps} from 'formik';
import {PillButton} from '../../../components/Button';
import TextField, {TextFieldProps} from '../../../components/TextField';
import FormField from '../../../components/FormField';
import Flex from '../../../components/Flex';

export interface FormValues {
  currentPassword: string;
  newPassword: string;
  newPasswordConfirm: string;
}

interface ChangePasswordBaseFormProps extends FormikProps<FormValues> {
  invalidCurrentPassword: boolean;
  loading: boolean;
}

// TODO: Add error message display capability to TextField component.
const ErrorMessage = ({children, show}: {children: React.ReactNode; show: boolean}) => {
  if (show) {
    return <div style={{fontFamily: 'Roboto', color: '#C00', padding: '8px 0'}}>{children}</div>;
  }
  return null;
};

const SubmitButton = styled(PillButton)({
  [mq('laptopAndUp')]: {
    marginBottom: 100
  }
});

export default class BaseForm extends React.Component<ChangePasswordBaseFormProps, {}> {
  public render() {
    const {
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      handleSubmit,
      invalidCurrentPassword,
      loading
    } = this.props;

    const commonFieldProps: TextFieldProps = {
      onChange: handleChange,
      onBlur: handleBlur,
      large: true
    };

    return (
      <form onSubmit={handleSubmit}>
        <FormField label="Current password">
          <TextField type="password" id="currentPassword" value={values.currentPassword} {...commonFieldProps} />
          <ErrorMessage show={Boolean(errors.currentPassword && touched.currentPassword)}>
            {errors.currentPassword}
          </ErrorMessage>
          <ErrorMessage show={invalidCurrentPassword}>Invalid password.</ErrorMessage>
        </FormField>
        <FormField label="Password">
          <TextField type="password" id="newPassword" value={values.newPassword} {...commonFieldProps} />
          <ErrorMessage show={Boolean(errors.newPassword && touched.newPassword)}>{errors.newPassword}</ErrorMessage>
        </FormField>
        <FormField label="Password Confirmation">
          <TextField type="password" id="newPasswordConfirm" value={values.newPasswordConfirm} {...commonFieldProps} />
          <ErrorMessage show={Boolean(errors.newPasswordConfirm && touched.newPasswordConfirm)}>
            {errors.newPasswordConfirm}
          </ErrorMessage>
        </FormField>
        <Flex center={true}>
          <SubmitButton type="submit" variant="primary" loading={loading} large={true}>
            Submit
          </SubmitButton>
        </Flex>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ChangePasswordForm/private/BaseForm.tsx